<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
		<rect id="Rectangle_14869" data-name="Rectangle 14869" width="30" height="30" rx="8" fill="#7e7fe7" />
		<path
			id="Path_30440"
			data-name="Path 30440"
			d="M4.5,12A1.5,1.5,0,1,1,6,13.5,1.5,1.5,0,0,1,4.5,12Zm6,0A1.5,1.5,0,1,1,12,13.5,1.5,1.5,0,0,1,10.5,12Zm6,0A1.5,1.5,0,1,1,18,13.5,1.5,1.5,0,0,1,16.5,12Z"
			transform="translate(3.5 3.5)"
			fill="#fff"
			fill-rule="evenodd"
		/>
	</svg>
</template>

<script>
export default {
	name: 'ThreeDotMenuSvg',
};
</script>

<style scoped lang="scss"></style>
